import axios from 'axios';

import { Id, PagedParams, PagedResponse, getData } from '@feature/utils';

import { Conference, ConferenceRequest } from './ConferenceTypes';

export function getPaged(params: PagedParams) {
  return axios
    .get<PagedResponse<Conference>>('/conferences/paged', {
      params,
    })
    .then(getData);
}

export function get(id: Id) {
  return axios.get<Conference>(`/conferences/${id}`).then(getData);
}

export function edit(id: Id, request: ConferenceRequest) {
  return axios.put<Conference>(`/conferences/${id}`, request).then(getData);
}

export function create(request: ConferenceRequest) {
  return axios.post<Conference>(`/conferences`, request).then(getData);
}

export function deleteById(id: Id) {
  return axios.delete<unknown>(`/conferences/${id}`).then(getData);
}
